<template>
  <li role="presentation">
    <component
      role="menuitem"
      :disabled="disabled"
      :target="target"
      @click="clicked"
      :aria-disabled="disabled ? true : null"
      :class="[linkClass, { activeClass: active }]"
      :is="computedTag"
      :href="computedTag === 'a' ? href : null"
      class="dropdown-item"
      :type="computedTag === 'button' ? 'button' : null">
      <slot />
    </component>
  </li>
</template>

<script setup lang="ts">
import { computed, inject, type Ref } from "vue";
import { type DropdownState } from "./RdsDropdown.vue";

interface Props {
  linkClass?: string;
  stayOpenOnInteract?: boolean;
  activeClass?: string;
  active?: boolean;
  href?: string;
  rel?: string;
  target?: "_self" | "_blank" | "_parent" | "_top";
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  target: "_self",
});

const dropdownState = inject<Ref<DropdownState>>("rds-dropdown-state");

// events
const emits = defineEmits<{
  /**
   *  Emitted when link/ button is clicked.
   */
  (e: "click", event: Event): void;
}>();

const computedTag = computed(() => {
  return props.href ? "a" : "button";
});

const clicked = (e: Event): void => {
  props.stayOpenOnInteract
    ? null
    : dropdownState
      ? (dropdownState.value.active = false)
      : null;
  emits("click", e);
};
</script>

<style scoped></style>
